import { EMarkAsViewedActionType, IMarkAsViewedSucceedPayload } from './types';
import {
  markAsViewed as browserMarkAsViewed,
  isAvailable as isViewedClustersAvailable,
} from '../../../../browser/utils/viewedClusters';
import {
  fetchMarkOffersAsViewed,
  TMarkOffersAsViewedResponse,
} from '../../repositories/viewed-offers/v1/mark-offers-as-viewed';
import { TThunkAction } from '../../types/redux';
import { ResponseError } from '../../utils/errors/ResponseError';
import { actionGenerator } from '../../utils/redux/actionGenerator';

const setStatusLoading = actionGenerator<EMarkAsViewedActionType.Loading>(EMarkAsViewedActionType.Loading);
const setStatusSucceed = actionGenerator<EMarkAsViewedActionType.Succeed, IMarkAsViewedSucceedPayload>(
  EMarkAsViewedActionType.Succeed,
);
const setStatusFailed = actionGenerator<EMarkAsViewedActionType.Failed>(EMarkAsViewedActionType.Failed);

interface IMarkOfferAsViewedParameters {
  /** cianId открытого объявления: просмотренным помечается только оно */
  cianId: number;
  isDetailed: boolean;
}

export function markOfferAsViewed({ cianId, isDetailed }: IMarkOfferAsViewedParameters): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { httpApi } = context;

    dispatch(setStatusLoading());

    if (!isDetailed) {
      if (isViewedClustersAvailable()) {
        browserMarkAsViewed(cianId);
        dispatch(setStatusSucceed({ cianIds: [cianId] }));
      }

      return;
    }

    try {
      const markAsViewedResponse: TMarkOffersAsViewedResponse = await fetchMarkOffersAsViewed({
        httpApi,
        parameters: {
          fromPin: true,
          offersId: [cianId],
        },
      });

      if (markAsViewedResponse.statusCode !== 200 && markAsViewedResponse.statusCode !== 204) {
        throw new ResponseError({
          domain: 'viewed#markAsViewed',
          message: markAsViewedResponse.response.message,
          details: {
            error: markAsViewedResponse.response.errors,
          },
        });
      }

      dispatch(setStatusSucceed({ cianIds: [cianId] }));
    } catch (error) {
      const { logger } = context;

      logger.error(error);

      dispatch(setStatusFailed());
    }
  };
}
